import React, { useState, useEffect } from 'react';
import { NativeSelect, FormControl } from '@material-ui/core';

import { fetchCountries } from '../../api';

import styles from './CountryPicker.module.css';

var countriesMap = [
  {
  "totalConfirmed": 1486757,
  "totalRecovered": 272265,
  "countryCode": "US",
  "slug": "united-states",
  "newConfirmed": 18937,
  "newDeaths": 808,
  "totalDeaths": 89562,
  "newRecovered": 3889,
  "country": "United States of America",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 281752,
  "totalRecovered": 67373,
  "countryCode": "RU",
  "slug": "russia",
  "newConfirmed": 9709,
  "newDeaths": 94,
  "totalDeaths": 2631,
  "newRecovered": 4207,
  "country": "Russian Federation",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 244995,
  "totalRecovered": 1058,
  "countryCode": "GB",
  "slug": "united-kingdom",
  "newConfirmed": 3534,
  "newDeaths": 170,
  "totalDeaths": 34716,
  "newRecovered": 0,
  "country": "United Kingdom",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 241080,
  "totalRecovered": 94122,
  "countryCode": "BR",
  "slug": "brazil",
  "newConfirmed": 7569,
  "newDeaths": 456,
  "totalDeaths": 16118,
  "newRecovered": 4450,
  "country": "Brazil",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 230698,
  "totalRecovered": 146446,
  "countryCode": "ES",
  "slug": "spain",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 27563,
  "newRecovered": 0,
  "country": "Spain",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 225435,
  "totalRecovered": 125176,
  "countryCode": "IT",
  "slug": "italy",
  "newConfirmed": 675,
  "newDeaths": 145,
  "totalDeaths": 31908,
  "newRecovered": 2366,
  "country": "Italy",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 179693,
  "totalRecovered": 61327,
  "countryCode": "FR",
  "slug": "france",
  "newConfirmed": 63,
  "newDeaths": 579,
  "totalDeaths": 28111,
  "newRecovered": 765,
  "country": "France",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 176369,
  "totalRecovered": 154011,
  "countryCode": "DE",
  "slug": "germany",
  "newConfirmed": 617,
  "newDeaths": 24,
  "totalDeaths": 7962,
  "newRecovered": 1411,
  "country": "Germany",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 156662,
  "totalRecovered": 38563,
  "countryCode": "CA",
  "slug": "canada",
  "newConfirmed": 2252,
  "newDeaths": 206,
  "totalDeaths": 11804,
  "newRecovered": 731,
  "country": "Canada",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 149435,
  "totalRecovered": 109962,
  "countryCode": "TR",
  "slug": "turkey",
  "newConfirmed": 1368,
  "newDeaths": 44,
  "totalDeaths": 4140,
  "newRecovered": 1825,
  "country": "Turkey",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 120198,
  "totalRecovered": 94464,
  "countryCode": "IR",
  "slug": "iran",
  "newConfirmed": 1806,
  "newDeaths": 51,
  "totalDeaths": 6988,
  "newRecovered": 1317,
  "country": "Iran, Islamic Republic of",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 95698,
  "totalRecovered": 36795,
  "countryCode": "IN",
  "slug": "india",
  "newConfirmed": 5050,
  "newDeaths": 154,
  "totalDeaths": 3025,
  "newRecovered": 2571,
  "country": "India",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 92273,
  "totalRecovered": 28621,
  "countryCode": "PE",
  "slug": "peru",
  "newConfirmed": 3732,
  "newDeaths": 125,
  "totalDeaths": 2648,
  "newRecovered": 349,
  "country": "Peru",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 84054,
  "totalRecovered": 79306,
  "countryCode": "CN",
  "slug": "china",
  "newConfirmed": 10,
  "newDeaths": 0,
  "totalDeaths": 4638,
  "newRecovered": 13,
  "country": "China",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 55280,
  "totalRecovered": 14630,
  "countryCode": "BE",
  "slug": "belgium",
  "newConfirmed": 291,
  "newDeaths": 47,
  "totalDeaths": 9052,
  "newRecovered": 170,
  "country": "Belgium",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 54752,
  "totalRecovered": 25722,
  "countryCode": "SA",
  "slug": "saudi-arabia",
  "newConfirmed": 2736,
  "newDeaths": 10,
  "totalDeaths": 312,
  "newRecovered": 2056,
  "country": "Saudi Arabia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 49219,
  "totalRecovered": 33329,
  "countryCode": "MX",
  "slug": "mexico",
  "newConfirmed": 2075,
  "newDeaths": 132,
  "totalDeaths": 5177,
  "newRecovered": 1481,
  "country": "Mexico",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 44195,
  "totalRecovered": 167,
  "countryCode": "NL",
  "slug": "netherlands",
  "newConfirmed": 125,
  "newDeaths": 10,
  "totalDeaths": 5699,
  "newRecovered": 0,
  "country": "Netherlands",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 43781,
  "totalRecovered": 19213,
  "countryCode": "CL",
  "slug": "chile",
  "newConfirmed": 2353,
  "newDeaths": 29,
  "totalDeaths": 450,
  "newRecovered": 1199,
  "country": "Chile",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 40151,
  "totalRecovered": 11341,
  "countryCode": "PK",
  "slug": "pakistan",
  "newConfirmed": 1352,
  "newDeaths": 39,
  "totalDeaths": 873,
  "newRecovered": 461,
  "country": "Pakistan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 33182,
  "totalRecovered": 3433,
  "countryCode": "EC",
  "slug": "ecuador",
  "newConfirmed": 419,
  "newDeaths": 48,
  "totalDeaths": 2736,
  "newRecovered": 0,
  "country": "Ecuador",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 32604,
  "totalRecovered": 4370,
  "countryCode": "QA",
  "slug": "qatar",
  "newConfirmed": 1632,
  "newDeaths": 0,
  "totalDeaths": 15,
  "newRecovered": 582,
  "country": "Qatar",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 30587,
  "totalRecovered": 27500,
  "countryCode": "CH",
  "slug": "switzerland",
  "newConfirmed": 15,
  "newDeaths": 2,
  "totalDeaths": 1881,
  "newRecovered": 100,
  "country": "Switzerland",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 30143,
  "totalRecovered": 4971,
  "countryCode": "SE",
  "slug": "sweden",
  "newConfirmed": 466,
  "newDeaths": 5,
  "totalDeaths": 3679,
  "newRecovered": 0,
  "country": "Sweden",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 29650,
  "totalRecovered": 9932,
  "countryCode": "BY",
  "slug": "belarus",
  "newConfirmed": 969,
  "newDeaths": 5,
  "totalDeaths": 165,
  "newRecovered": 434,
  "country": "Belarus",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 29036,
  "totalRecovered": 4636,
  "countryCode": "PT",
  "slug": "portugal",
  "newConfirmed": 226,
  "newDeaths": 15,
  "totalDeaths": 1218,
  "newRecovered": 814,
  "country": "Portugal",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 28038,
  "totalRecovered": 9340,
  "countryCode": "SG",
  "slug": "singapore",
  "newConfirmed": 682,
  "newDeaths": 0,
  "totalDeaths": 22,
  "newRecovered": 998,
  "country": "Singapore",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 24112,
  "totalRecovered": 19470,
  "countryCode": "IE",
  "slug": "ireland",
  "newConfirmed": 64,
  "newDeaths": 10,
  "totalDeaths": 1543,
  "newRecovered": 0,
  "country": "Ireland",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 23358,
  "totalRecovered": 8512,
  "countryCode": "AE",
  "slug": "united-arab-emirates",
  "newConfirmed": 731,
  "newDeaths": 6,
  "totalDeaths": 220,
  "newRecovered": 581,
  "country": "United Arab Emirates",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 22268,
  "totalRecovered": 4373,
  "countryCode": "BD",
  "slug": "bangladesh",
  "newConfirmed": 1273,
  "newDeaths": 14,
  "totalDeaths": 328,
  "newRecovered": 256,
  "country": "Bangladesh",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 18529,
  "totalRecovered": 7451,
  "countryCode": "PL",
  "slug": "poland",
  "newConfirmed": 272,
  "newDeaths": 10,
  "totalDeaths": 925,
  "newRecovered": 276,
  "country": "Poland",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 18291,
  "totalRecovered": 5116,
  "countryCode": "UA",
  "slug": "ukraine",
  "newConfirmed": 433,
  "newDeaths": 17,
  "totalDeaths": 514,
  "newRecovered": 210,
  "country": "Ukraine",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 17514,
  "totalRecovered": 4129,
  "countryCode": "ID",
  "slug": "indonesia",
  "newConfirmed": 489,
  "newDeaths": 59,
  "totalDeaths": 1148,
  "newRecovered": 218,
  "country": "Indonesia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 16871,
  "totalRecovered": 9890,
  "countryCode": "RO",
  "slug": "romania",
  "newConfirmed": 167,
  "newDeaths": 13,
  "totalDeaths": 1107,
  "newRecovered": 316,
  "country": "Romania",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 16617,
  "totalRecovered": 12942,
  "countryCode": "IL",
  "slug": "israel",
  "newConfirmed": 9,
  "newDeaths": 4,
  "totalDeaths": 272,
  "newRecovered": 87,
  "country": "Israel",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 16285,
  "totalRecovered": 11153,
  "countryCode": "JP",
  "slug": "japan",
  "newConfirmed": 48,
  "newDeaths": 19,
  "totalDeaths": 744,
  "newRecovered": 815,
  "country": "Japan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 16242,
  "totalRecovered": 14563,
  "countryCode": "AT",
  "slug": "austria",
  "newConfirmed": 41,
  "newDeaths": 0,
  "totalDeaths": 629,
  "newRecovered": 39,
  "country": "Austria",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 15574,
  "totalRecovered": 3751,
  "countryCode": "CO",
  "slug": "colombia",
  "newConfirmed": 635,
  "newDeaths": 12,
  "totalDeaths": 574,
  "newRecovered": 164,
  "country": "Colombia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 15515,
  "totalRecovered": 7006,
  "countryCode": "ZA",
  "slug": "south-africa",
  "newConfirmed": 1160,
  "newDeaths": 3,
  "totalDeaths": 264,
  "newRecovered": 528,
  "country": "South Africa",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 14850,
  "totalRecovered": 4093,
  "countryCode": "KW",
  "slug": "kuwait",
  "newConfirmed": 1048,
  "newDeaths": 5,
  "totalDeaths": 112,
  "newRecovered": 250,
  "country": "Kuwait",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 12513,
  "totalRecovered": 2635,
  "countryCode": "PH",
  "slug": "philippines",
  "newConfirmed": 208,
  "newDeaths": 7,
  "totalDeaths": 824,
  "newRecovered": 74,
  "country": "Philippines",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 12314,
  "totalRecovered": 5847,
  "countryCode": "DO",
  "slug": "dominican-republic",
  "newConfirmed": 204,
  "newDeaths": 0,
  "totalDeaths": 428,
  "newRecovered": 2121,
  "country": "Dominican Republic",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 12229,
  "totalRecovered": 3172,
  "countryCode": "EG",
  "slug": "egypt",
  "newConfirmed": 510,
  "newDeaths": 18,
  "totalDeaths": 630,
  "newRecovered": 222,
  "country": "Egypt",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 11125,
  "totalRecovered": 9425,
  "countryCode": "DK",
  "slug": "denmark",
  "newConfirmed": 69,
  "newDeaths": 4,
  "totalDeaths": 547,
  "newRecovered": 120,
  "country": "Denmark",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 11065,
  "totalRecovered": 9904,
  "countryCode": "KR",
  "slug": "korea-south",
  "newConfirmed": 15,
  "newDeaths": 1,
  "totalDeaths": 263,
  "newRecovered": 16,
  "country": "Korea (South)",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 10610,
  "totalRecovered": 4713,
  "countryCode": "RS",
  "slug": "serbia",
  "newConfirmed": 114,
  "newDeaths": 2,
  "totalDeaths": 230,
  "newRecovered": 234,
  "country": "Serbia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 9606,
  "totalRecovered": 6081,
  "countryCode": "PA",
  "slug": "panama",
  "newConfirmed": 157,
  "newDeaths": 6,
  "totalDeaths": 275,
  "newRecovered": 1,
  "country": "Panama",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 8475,
  "totalRecovered": 5462,
  "countryCode": "CZ",
  "slug": "czech-republic",
  "newConfirmed": 20,
  "newDeaths": 2,
  "totalDeaths": 298,
  "newRecovered": 40,
  "country": "Czech Republic",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 8249,
  "totalRecovered": 32,
  "countryCode": "NO",
  "slug": "norway",
  "newConfirmed": 12,
  "newDeaths": 0,
  "totalDeaths": 232,
  "newRecovered": 0,
  "country": "Norway",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 8068,
  "totalRecovered": 2569,
  "countryCode": "AR",
  "slug": "argentina",
  "newConfirmed": 263,
  "newDeaths": 10,
  "totalDeaths": 373,
  "newRecovered": 35,
  "country": "Argentina",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 7054,
  "totalRecovered": 6392,
  "countryCode": "AU",
  "slug": "australia",
  "newConfirmed": 10,
  "newDeaths": 1,
  "totalDeaths": 99,
  "newRecovered": 28,
  "country": "Australia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 7019,
  "totalRecovered": 3507,
  "countryCode": "DZ",
  "slug": "algeria",
  "newConfirmed": 198,
  "newDeaths": 6,
  "totalDeaths": 548,
  "newRecovered": 98,
  "country": "Algeria",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 6956,
  "totalRecovered": 2910,
  "countryCode": "BH",
  "slug": "bahrain",
  "newConfirmed": 209,
  "newDeaths": 0,
  "totalDeaths": 12,
  "newRecovered": 148,
  "country": "Bahrain",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 6894,
  "totalRecovered": 5571,
  "countryCode": "MY",
  "slug": "malaysia",
  "newConfirmed": 22,
  "newDeaths": 0,
  "totalDeaths": 113,
  "newRecovered": 59,
  "country": "Malaysia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 6870,
  "totalRecovered": 3660,
  "countryCode": "MA",
  "slug": "morocco",
  "newConfirmed": 129,
  "newDeaths": 0,
  "totalDeaths": 192,
  "newRecovered": 173,
  "country": "Morocco",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 6664,
  "totalRecovered": 778,
  "countryCode": "AF",
  "slug": "afghanistan",
  "newConfirmed": 262,
  "newDeaths": 1,
  "totalDeaths": 169,
  "newRecovered": 33,
  "country": "Afghanistan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 6347,
  "totalRecovered": 5000,
  "countryCode": "FI",
  "slug": "finland",
  "newConfirmed": 61,
  "newDeaths": 1,
  "totalDeaths": 298,
  "newRecovered": 0,
  "country": "Finland",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 6157,
  "totalRecovered": 3256,
  "countryCode": "KZ",
  "slug": "kazakhstan",
  "newConfirmed": 307,
  "newDeaths": 0,
  "totalDeaths": 34,
  "newRecovered": 276,
  "country": "Kazakhstan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 6060,
  "totalRecovered": 2344,
  "countryCode": "MD",
  "slug": "moldova",
  "newConfirmed": 126,
  "newDeaths": 4,
  "totalDeaths": 211,
  "newRecovered": 0,
  "country": "Moldova",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 5959,
  "totalRecovered": 1594,
  "countryCode": "NG",
  "slug": "nigeria",
  "newConfirmed": 338,
  "newDeaths": 6,
  "totalDeaths": 182,
  "newRecovered": 122,
  "country": "Nigeria",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 5735,
  "totalRecovered": 1754,
  "countryCode": "GH",
  "slug": "ghana",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 29,
  "newRecovered": 0,
  "country": "Ghana",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 5186,
  "totalRecovered": 1465,
  "countryCode": "OM",
  "slug": "oman",
  "newConfirmed": 157,
  "newDeaths": 1,
  "totalDeaths": 22,
  "newRecovered": 29,
  "country": "Oman",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 4472,
  "totalRecovered": 1925,
  "countryCode": "AM",
  "slug": "armenia",
  "newConfirmed": 189,
  "newDeaths": 5,
  "totalDeaths": 60,
  "newRecovered": 134,
  "country": "Armenia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 4088,
  "totalRecovered": 493,
  "countryCode": "BO",
  "slug": "bolivia",
  "newConfirmed": 262,
  "newDeaths": 4,
  "totalDeaths": 169,
  "newRecovered": 20,
  "country": "Bolivia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 3945,
  "totalRecovered": 3702,
  "countryCode": "LU",
  "slug": "luxembourg",
  "newConfirmed": 15,
  "newDeaths": 3,
  "totalDeaths": 107,
  "newRecovered": 3,
  "country": "Luxembourg",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 3509,
  "totalRecovered": 1396,
  "countryCode": "HU",
  "slug": "hungary",
  "newConfirmed": 36,
  "newDeaths": 3,
  "totalDeaths": 451,
  "newRecovered": 25,
  "country": "Hungary",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 3404,
  "totalRecovered": 2218,
  "countryCode": "IQ",
  "slug": "iraq",
  "newConfirmed": 144,
  "newDeaths": 2,
  "totalDeaths": 123,
  "newRecovered": 92,
  "country": "Iraq",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 3274,
  "totalRecovered": 2015,
  "countryCode": "AZ",
  "slug": "azerbaijan",
  "newConfirmed": 136,
  "newDeaths": 3,
  "totalDeaths": 39,
  "newRecovered": 71,
  "country": "Azerbaijan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 3105,
  "totalRecovered": 1567,
  "countryCode": "CM",
  "slug": "cameroon",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 140,
  "newRecovered": 0,
  "country": "Cameroon",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 3028,
  "totalRecovered": 2856,
  "countryCode": "TH",
  "slug": "thailand",
  "newConfirmed": 3,
  "newDeaths": 0,
  "totalDeaths": 56,
  "newRecovered": 1,
  "country": "Thailand",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2834,
  "totalRecovered": 1374,
  "countryCode": "GR",
  "slug": "greece",
  "newConfirmed": 15,
  "newDeaths": 1,
  "totalDeaths": 163,
  "newRecovered": 0,
  "country": "Greece",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2753,
  "totalRecovered": 2247,
  "countryCode": "UZ",
  "slug": "uzbekistan",
  "newConfirmed": 15,
  "newDeaths": 1,
  "totalDeaths": 12,
  "newRecovered": 34,
  "country": "Uzbekistan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2658,
  "totalRecovered": 1133,
  "countryCode": "GN",
  "slug": "guinea",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 16,
  "newRecovered": 0,
  "country": "Guinea",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2646,
  "totalRecovered": 319,
  "countryCode": "HN",
  "slug": "honduras",
  "newConfirmed": 81,
  "newDeaths": 4,
  "totalDeaths": 142,
  "newRecovered": 41,
  "country": "Honduras",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2480,
  "totalRecovered": 973,
  "countryCode": "SN",
  "slug": "senegal",
  "newConfirmed": 51,
  "newDeaths": 0,
  "totalDeaths": 25,
  "newRecovered": 24,
  "country": "Senegal",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2290,
  "totalRecovered": 1436,
  "countryCode": "BA",
  "slug": "bosnia-and-herzegovina",
  "newConfirmed": 23,
  "newDeaths": 4,
  "totalDeaths": 133,
  "newRecovered": 81,
  "country": "Bosnia and Herzegovina",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2289,
  "totalRecovered": 222,
  "countryCode": "SD",
  "slug": "sudan",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 97,
  "newRecovered": 0,
  "country": "Sudan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2226,
  "totalRecovered": 1936,
  "countryCode": "HR",
  "slug": "croatia",
  "newConfirmed": 2,
  "newDeaths": 0,
  "totalDeaths": 95,
  "newRecovered": 23,
  "country": "Croatia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2211,
  "totalRecovered": 598,
  "countryCode": "BG",
  "slug": "bulgaria",
  "newConfirmed": 36,
  "newDeaths": 3,
  "totalDeaths": 108,
  "newRecovered": 25,
  "country": "Bulgaria",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 2109,
  "totalRecovered": 1004,
  "countryCode": "CI",
  "slug": "cote-divoire",
  "newConfirmed": 48,
  "newDeaths": 2,
  "totalDeaths": 27,
  "newRecovered": 17,
  "country": "Côte d'Ivoire",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1872,
  "totalRecovered": 1495,
  "countryCode": "CU",
  "slug": "cuba",
  "newConfirmed": 10,
  "newDeaths": 0,
  "totalDeaths": 79,
  "newRecovered": 35,
  "country": "Cuba",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1802,
  "totalRecovered": 1786,
  "countryCode": "IS",
  "slug": "iceland",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 10,
  "newRecovered": 0,
  "country": "Iceland",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1792,
  "totalRecovered": 1293,
  "countryCode": "MK",
  "slug": "macedonia",
  "newConfirmed": 30,
  "newDeaths": 3,
  "totalDeaths": 101,
  "newRecovered": 26,
  "country": "Macedonia, Republic of",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1774,
  "totalRecovered": 938,
  "countryCode": "EE",
  "slug": "estonia",
  "newConfirmed": 4,
  "newDeaths": 0,
  "totalDeaths": 63,
  "newRecovered": 4,
  "country": "Estonia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1763,
  "totalRecovered": 138,
  "countryCode": "GT",
  "slug": "guatemala",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 33,
  "newRecovered": 0,
  "country": "Guatemala",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1541,
  "totalRecovered": 997,
  "countryCode": "LT",
  "slug": "lithuania",
  "newConfirmed": 7,
  "newDeaths": 1,
  "totalDeaths": 56,
  "newRecovered": 9,
  "country": "Lithuania",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1524,
  "totalRecovered": 0,
  "countryCode": "TJ",
  "slug": "tajikistan",
  "newConfirmed": 202,
  "newDeaths": 3,
  "totalDeaths": 39,
  "newRecovered": 0,
  "country": "Tajikistan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1499,
  "totalRecovered": 1433,
  "countryCode": "NZ",
  "slug": "new-zealand",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 21,
  "newRecovered": 0,
  "country": "New Zealand",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1494,
  "totalRecovered": 1163,
  "countryCode": "SK",
  "slug": "slovakia",
  "newConfirmed": 1,
  "newDeaths": 0,
  "totalDeaths": 28,
  "newRecovered": 12,
  "country": "Slovakia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1466,
  "totalRecovered": 273,
  "countryCode": "SI",
  "slug": "slovenia",
  "newConfirmed": 1,
  "newDeaths": 1,
  "totalDeaths": 104,
  "newRecovered": 1,
  "country": "Slovenia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1455,
  "totalRecovered": 270,
  "countryCode": "CD",
  "slug": "congo-kinshasa",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 61,
  "newRecovered": 0,
  "country": "Congo (Kinshasa)",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1421,
  "totalRecovered": 152,
  "countryCode": "SO",
  "slug": "somalia",
  "newConfirmed": 64,
  "newDeaths": 1,
  "totalDeaths": 56,
  "newRecovered": 4,
  "country": "Somalia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1401,
  "totalRecovered": 972,
  "countryCode": "DJ",
  "slug": "djibouti",
  "newConfirmed": 70,
  "newDeaths": 0,
  "totalDeaths": 4,
  "newRecovered": 22,
  "country": "Djibouti",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1338,
  "totalRecovered": 464,
  "countryCode": "SV",
  "slug": "el-salvador",
  "newConfirmed": 73,
  "newDeaths": 4,
  "totalDeaths": 30,
  "newRecovered": 23,
  "country": "El Salvador",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1320,
  "totalRecovered": 244,
  "countryCode": "GA",
  "slug": "gabon",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 11,
  "newRecovered": 0,
  "country": "Gabon",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1138,
  "totalRecovered": 804,
  "countryCode": "KG",
  "slug": "kyrgyzstan",
  "newConfirmed": 21,
  "newDeaths": 0,
  "totalDeaths": 14,
  "newRecovered": 21,
  "country": "Kyrgyzstan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1094,
  "totalRecovered": 58,
  "countryCode": "MV",
  "slug": "maldives",
  "newConfirmed": 16,
  "newDeaths": 0,
  "totalDeaths": 4,
  "newRecovered": 0,
  "country": "Maldives",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1037,
  "totalRecovered": 816,
  "countryCode": "TN",
  "slug": "tunisia",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 45,
  "newRecovered": 9,
  "country": "Tunisia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1008,
  "totalRecovered": 662,
  "countryCode": "LV",
  "slug": "latvia",
  "newConfirmed": 11,
  "newDeaths": 0,
  "totalDeaths": 19,
  "newRecovered": 0,
  "country": "Latvia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 990,
  "totalRecovered": 26,
  "countryCode": "GW",
  "slug": "guinea-bissau",
  "newConfirmed": 21,
  "newDeaths": 0,
  "totalDeaths": 4,
  "newRecovered": 0,
  "country": "Guinea-Bissau",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 981,
  "totalRecovered": 538,
  "countryCode": "LK",
  "slug": "sri-lanka",
  "newConfirmed": 21,
  "newDeaths": 0,
  "totalDeaths": 9,
  "newRecovered": 18,
  "country": "Sri Lanka",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 955,
  "totalRecovered": 691,
  "countryCode": "XK",
  "slug": "kosovo",
  "newConfirmed": 11,
  "newDeaths": 0,
  "totalDeaths": 29,
  "newRecovered": 1,
  "country": "Republic of Kosovo",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 946,
  "totalRecovered": 715,
  "countryCode": "AL",
  "slug": "albania",
  "newConfirmed": 13,
  "newDeaths": 0,
  "totalDeaths": 31,
  "newRecovered": 1,
  "country": "Albania",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 916,
  "totalRecovered": 515,
  "countryCode": "CY",
  "slug": "cyprus",
  "newConfirmed": 2,
  "newDeaths": 0,
  "totalDeaths": 17,
  "newRecovered": 0,
  "country": "Cyprus",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 911,
  "totalRecovered": 247,
  "countryCode": "LB",
  "slug": "lebanon",
  "newConfirmed": 9,
  "newDeaths": 0,
  "totalDeaths": 26,
  "newRecovered": 0,
  "country": "Lebanon",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 904,
  "totalRecovered": 698,
  "countryCode": "NE",
  "slug": "niger",
  "newConfirmed": 15,
  "newDeaths": 3,
  "totalDeaths": 54,
  "newRecovered": 9,
  "country": "Niger",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 887,
  "totalRecovered": 313,
  "countryCode": "KE",
  "slug": "kenya",
  "newConfirmed": 57,
  "newDeaths": 0,
  "totalDeaths": 50,
  "newRecovered": 12,
  "country": "Kenya",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 863,
  "totalRecovered": 565,
  "countryCode": "CR",
  "slug": "costa-rica",
  "newConfirmed": 10,
  "newDeaths": 0,
  "totalDeaths": 10,
  "newRecovered": 14,
  "country": "Costa Rica",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 860,
  "totalRecovered": 494,
  "countryCode": "ML",
  "slug": "mali",
  "newConfirmed": 25,
  "newDeaths": 4,
  "totalDeaths": 52,
  "newRecovered": 15,
  "country": "Mali",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 796,
  "totalRecovered": 644,
  "countryCode": "BF",
  "slug": "burkina-faso",
  "newConfirmed": 14,
  "newDeaths": 0,
  "totalDeaths": 51,
  "newRecovered": 40,
  "country": "Burkina Faso",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 786,
  "totalRecovered": 202,
  "countryCode": "PY",
  "slug": "paraguay",
  "newConfirmed": 8,
  "newDeaths": 0,
  "totalDeaths": 11,
  "newRecovered": 4,
  "country": "Paraguay",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 761,
  "totalRecovered": 617,
  "countryCode": "AD",
  "slug": "andorra",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 51,
  "newRecovered": 2,
  "country": "Andorra",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 753,
  "totalRecovered": 188,
  "countryCode": "ZM",
  "slug": "zambia",
  "newConfirmed": 74,
  "newDeaths": 0,
  "totalDeaths": 7,
  "newRecovered": 5,
  "country": "Zambia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 734,
  "totalRecovered": 564,
  "countryCode": "UY",
  "slug": "uruguay",
  "newConfirmed": 1,
  "newDeaths": 1,
  "totalDeaths": 20,
  "newRecovered": 6,
  "country": "Uruguay",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 695,
  "totalRecovered": 425,
  "countryCode": "GE",
  "slug": "georgia",
  "newConfirmed": 12,
  "newDeaths": 0,
  "totalDeaths": 12,
  "newRecovered": 6,
  "country": "Georgia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 654,
  "totalRecovered": 201,
  "countryCode": "SM",
  "slug": "san-marino",
  "newConfirmed": 1,
  "newDeaths": 0,
  "totalDeaths": 41,
  "newRecovered": 3,
  "country": "San Marino",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 613,
  "totalRecovered": 408,
  "countryCode": "JO",
  "slug": "jordan",
  "newConfirmed": 6,
  "newDeaths": 0,
  "totalDeaths": 9,
  "newRecovered": 4,
  "country": "Jordan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 594,
  "totalRecovered": 22,
  "countryCode": "GQ",
  "slug": "equatorial-guinea",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 7,
  "newRecovered": 0,
  "country": "Equatorial Guinea",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 553,
  "totalRecovered": 454,
  "countryCode": "MT",
  "slug": "malta",
  "newConfirmed": 7,
  "newDeaths": 0,
  "totalDeaths": 6,
  "newRecovered": 4,
  "country": "Malta",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 541,
  "totalRecovered": 241,
  "countryCode": "VE",
  "slug": "venezuela",
  "newConfirmed": 37,
  "newDeaths": 0,
  "totalDeaths": 10,
  "newRecovered": 0,
  "country": "Venezuela (Bolivarian Republic)",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 520,
  "totalRecovered": 127,
  "countryCode": "JM",
  "slug": "jamaica",
  "newConfirmed": 3,
  "newDeaths": 0,
  "totalDeaths": 9,
  "newRecovered": 6,
  "country": "Jamaica",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 509,
  "totalRecovered": 183,
  "countryCode": "TZ",
  "slug": "tanzania",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 21,
  "newRecovered": 0,
  "country": "Tanzania, United Republic of",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 505,
  "totalRecovered": 141,
  "countryCode": "SL",
  "slug": "sierra-leone",
  "newConfirmed": 43,
  "newDeaths": 3,
  "totalDeaths": 32,
  "newRecovered": 35,
  "country": "Sierra Leone",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 503,
  "totalRecovered": 117,
  "countryCode": "TD",
  "slug": "chad",
  "newConfirmed": 29,
  "newDeaths": 3,
  "totalDeaths": 53,
  "newRecovered": 6,
  "country": "Chad",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 456,
  "totalRecovered": 29,
  "countryCode": "HT",
  "slug": "haiti",
  "newConfirmed": 98,
  "newDeaths": 0,
  "totalDeaths": 20,
  "newRecovered": 0,
  "country": "Haiti",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 440,
  "totalRecovered": 395,
  "countryCode": "TW",
  "slug": "taiwan",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 7,
  "newRecovered": 6,
  "country": "Taiwan, Republic of China",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 391,
  "totalRecovered": 87,
  "countryCode": "CG",
  "slug": "congo-brazzaville",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 15,
  "newRecovered": 0,
  "country": "Congo (Brazzaville)",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 381,
  "totalRecovered": 335,
  "countryCode": "PS",
  "slug": "palestine",
  "newConfirmed": 5,
  "newDeaths": 0,
  "totalDeaths": 2,
  "newRecovered": 6,
  "country": "Palestinian Territory",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 339,
  "totalRecovered": 83,
  "countryCode": "BJ",
  "slug": "benin",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 2,
  "newRecovered": 0,
  "country": "Benin",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 332,
  "totalRecovered": 322,
  "countryCode": "MU",
  "slug": "mauritius",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 10,
  "newRecovered": 0,
  "country": "Mauritius",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 328,
  "totalRecovered": 84,
  "countryCode": "CV",
  "slug": "cape-verde",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 3,
  "newRecovered": 0,
  "country": "Cape Verde",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 327,
  "totalRecovered": 13,
  "countryCode": "CF",
  "slug": "central-african-republic",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Central African Republic",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 324,
  "totalRecovered": 311,
  "countryCode": "ME",
  "slug": "montenegro",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 9,
  "newRecovered": 0,
  "country": "Montenegro",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 320,
  "totalRecovered": 260,
  "countryCode": "VN",
  "slug": "vietnam",
  "newConfirmed": 2,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Viet Nam",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 317,
  "totalRecovered": 113,
  "countryCode": "ET",
  "slug": "ethiopia",
  "newConfirmed": 11,
  "newDeaths": 0,
  "totalDeaths": 5,
  "newRecovered": 0,
  "country": "Ethiopia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 304,
  "totalRecovered": 114,
  "countryCode": "MG",
  "slug": "madagascar",
  "newConfirmed": 21,
  "newDeaths": 1,
  "totalDeaths": 1,
  "newRecovered": 0,
  "country": "Madagascar",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 301,
  "totalRecovered": 104,
  "countryCode": "TG",
  "slug": "togo",
  "newConfirmed": 3,
  "newDeaths": 0,
  "totalDeaths": 11,
  "newRecovered": 5,
  "country": "Togo",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 295,
  "totalRecovered": 36,
  "countryCode": "NP",
  "slug": "nepal",
  "newConfirmed": 4,
  "newDeaths": 1,
  "totalDeaths": 2,
  "newRecovered": 0,
  "country": "Nepal",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 292,
  "totalRecovered": 197,
  "countryCode": "RW",
  "slug": "rwanda",
  "newConfirmed": 3,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 19,
  "country": "Rwanda",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 290,
  "totalRecovered": 4,
  "countryCode": "SS",
  "slug": "south-sudan",
  "newConfirmed": 54,
  "newDeaths": 0,
  "totalDeaths": 4,
  "newRecovered": 0,
  "country": "South Sudan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 235,
  "totalRecovered": 4,
  "countryCode": "ST",
  "slug": "sao-tome-and-principe",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 7,
  "newRecovered": 0,
  "country": "Sao Tome and Principe",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 227,
  "totalRecovered": 63,
  "countryCode": "UG",
  "slug": "uganda",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Uganda",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 226,
  "totalRecovered": 120,
  "countryCode": "LR",
  "slug": "liberia",
  "newConfirmed": 3,
  "newDeaths": 1,
  "totalDeaths": 21,
  "newRecovered": 4,
  "country": "Liberia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 203,
  "totalRecovered": 73,
  "countryCode": "SZ",
  "slug": "swaziland",
  "newConfirmed": 1,
  "newDeaths": 0,
  "totalDeaths": 2,
  "newRecovered": 1,
  "country": "Swaziland",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 184,
  "totalRecovered": 97,
  "countryCode": "MM",
  "slug": "myanmar",
  "newConfirmed": 2,
  "newDeaths": 0,
  "totalDeaths": 6,
  "newRecovered": 1,
  "country": "Myanmar",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 141,
  "totalRecovered": 136,
  "countryCode": "BN",
  "slug": "brunei",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 1,
  "newRecovered": 0,
  "country": "Brunei Darussalam",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 137,
  "totalRecovered": 44,
  "countryCode": "MZ",
  "slug": "mozambique",
  "newConfirmed": 8,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 1,
  "country": "Mozambique",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 136,
  "totalRecovered": 21,
  "countryCode": "MN",
  "slug": "mongolia",
  "newConfirmed": 1,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 1,
  "country": "Mongolia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 128,
  "totalRecovered": 1,
  "countryCode": "YE",
  "slug": "yemen",
  "newConfirmed": 6,
  "newDeaths": 2,
  "totalDeaths": 20,
  "newRecovered": 0,
  "country": "Yemen",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 122,
  "totalRecovered": 122,
  "countryCode": "KH",
  "slug": "cambodia",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Cambodia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 117,
  "totalRecovered": 43,
  "countryCode": "GY",
  "slug": "guyana",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 10,
  "newRecovered": 0,
  "country": "Guyana",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 116,
  "totalRecovered": 107,
  "countryCode": "TT",
  "slug": "trinidad-and-tobago",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 8,
  "newRecovered": 0,
  "country": "Trinidad and Tobago",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 96,
  "totalRecovered": 87,
  "countryCode": "MC",
  "slug": "monaco",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 4,
  "newRecovered": 0,
  "country": "Monaco",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 88,
  "totalRecovered": 68,
  "countryCode": "BB",
  "slug": "barbados",
  "newConfirmed": 2,
  "newDeaths": 0,
  "totalDeaths": 7,
  "newRecovered": 1,
  "country": "Barbados",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 82,
  "totalRecovered": 55,
  "countryCode": "LI",
  "slug": "liechtenstein",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 1,
  "newRecovered": 0,
  "country": "Liechtenstein",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 70,
  "totalRecovered": 27,
  "countryCode": "MW",
  "slug": "malawi",
  "newConfirmed": 5,
  "newDeaths": 0,
  "totalDeaths": 3,
  "newRecovered": 3,
  "country": "Malawi",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 65,
  "totalRecovered": 35,
  "countryCode": "LY",
  "slug": "libya",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 3,
  "newRecovered": 7,
  "country": "Libya",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 62,
  "totalRecovered": 7,
  "countryCode": "MR",
  "slug": "mauritania",
  "newConfirmed": 22,
  "newDeaths": 0,
  "totalDeaths": 4,
  "newRecovered": 0,
  "country": "Mauritania",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 58,
  "totalRecovered": 36,
  "countryCode": "SY",
  "slug": "syria",
  "newConfirmed": 7,
  "newDeaths": 0,
  "totalDeaths": 3,
  "newRecovered": 0,
  "country": "Syrian Arab Republic (Syria)",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 48,
  "totalRecovered": 17,
  "countryCode": "AO",
  "slug": "angola",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 2,
  "newRecovered": 0,
  "country": "Angola",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 44,
  "totalRecovered": 17,
  "countryCode": "ZW",
  "slug": "zimbabwe",
  "newConfirmed": 2,
  "newDeaths": 0,
  "totalDeaths": 4,
  "newRecovered": 4,
  "country": "Zimbabwe",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 39,
  "totalRecovered": 39,
  "countryCode": "ER",
  "slug": "eritrea",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Eritrea",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 25,
  "totalRecovered": 7,
  "countryCode": "NI",
  "slug": "nicaragua",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 8,
  "newRecovered": 0,
  "country": "Nicaragua",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 24,
  "totalRecovered": 24,
  "countryCode": "TL",
  "slug": "timor-leste",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Timor-Leste",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 23,
  "totalRecovered": 12,
  "countryCode": "GM",
  "slug": "gambia",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 1,
  "newRecovered": 0,
  "country": "Gambia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 22,
  "totalRecovered": 14,
  "countryCode": "GD",
  "slug": "grenada",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Grenada",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 21,
  "totalRecovered": 5,
  "countryCode": "BT",
  "slug": "bhutan",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Bhutan",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 19,
  "totalRecovered": 14,
  "countryCode": "LA",
  "slug": "lao-pdr",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Lao PDR",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 18,
  "totalRecovered": 18,
  "countryCode": "LC",
  "slug": "saint-lucia",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Saint Lucia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 17,
  "totalRecovered": 14,
  "countryCode": "VC",
  "slug": "saint-vincent-and-the-grenadines",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Saint Vincent and Grenadines",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 16,
  "totalRecovered": 13,
  "countryCode": "NA",
  "slug": "namibia",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Namibia",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 15,
  "totalRecovered": 14,
  "countryCode": "KN",
  "slug": "saint-kitts-and-nevis",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Saint Kitts and Nevis",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 12,
  "totalRecovered": 2,
  "countryCode": "VA",
  "slug": "holy-see-vatican-city-state",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Holy See (Vatican City State)",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 11,
  "totalRecovered": 10,
  "countryCode": "SC",
  "slug": "seychelles",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Seychelles",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 10,
  "totalRecovered": 9,
  "countryCode": "SR",
  "slug": "suriname",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 1,
  "newRecovered": 0,
  "country": "Suriname",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 8,
  "totalRecovered": 8,
  "countryCode": "PG",
  "slug": "papua-new-guinea",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Papua New Guinea",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 6,
  "totalRecovered": 6,
  "countryCode": "EH",
  "slug": "western-sahara",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Western Sahara",
  "date": "2020-05-18T18:05:27Z"
  },
  {
  "totalConfirmed": 1,
  "totalRecovered": 0,
  "countryCode": "LS",
  "slug": "lesotho",
  "newConfirmed": 0,
  "newDeaths": 0,
  "totalDeaths": 0,
  "newRecovered": 0,
  "country": "Lesotho",
  "date": "2020-05-18T18:05:27Z"
  }
  ];

const Countries = ({ handleCountryChange }) => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchAPI = async () => {
      setCountries(await countriesMap);
    };

    fetchAPI();
  }, []);

  if(countries) {
    return (
      <FormControl className={styles.formControl}>
        <NativeSelect defaultValue="" onChange={(e) => handleCountryChange(e.target.value)}>
          <option value="">Global</option>
          {
            countries.map((country, i) => <option key={i} value={country.slug}>{country.country}</option>)
          }
        </NativeSelect>
      </FormControl>
    );
  } else {
    return null;
  }
};

export default Countries;
